import React from 'react';
import Footer from '../../components/footer';
import NGLVHeader from '../../components/header';



const IWanttoAcceptJesus = () => {
    return ( 
        <>
        <NGLVHeader />
             <div>
              
                <section id="intro" class="content-section">
                <div >
              <img src={require('../../../assets/NGLV_images/home_banner.png')} style={{ width: '100%', height: '350px' }} />
            </div>
                <div className='container-fluid content'>
                <div class="content-container">
    
      <p className='fsize'>“Yet to all who did receive him, to those who believed in his name, he gave the right to become children of God.”</p>
      <p className='fsize'>John 1:12</p>
    </div>
    <div className='container-fluid content'>
            
          
        <div className='row'>
            <div className='col-md-6'>
            <p className='fsize' style={{textAlign:'justify'}}>All we must do to become children of God is to receive Jesus Christ. If Jesus knocks on the door of your heart but you do not open it, you have not received him. If you open it a little, you still have not received him. But if you open the door wide, and invite him in, then you have received him. This is how we
become children of God. We open the door of our hearts to Jesus Christ and invite him in forever.
 
</p>
<p className='fsize'>You can receive Jesus Christ as your Lord and Savior by praying these words:</p>
<p style={{fontWeight:'bold',fontSize:'14px',fontStyle:'italic'}}>
<i>Dear Lord Jesus, I know that I am a sinner who deserves to be punished. But I also know that you took my punishment when you died on a cross for my sins, and that you rose from the dead to give me eternal life. So here and now, Lord Jesus, I invite you into my heart. Help me live each day for you until I see you face to face. Thank you for the gift of eternal life.</i>
Amen.
</p>
<p style={{fontWeight:'bold',fontSize:'12px',fontStyle:'italic'}}>Praise be to God! He is faithful and He loves you!</p>
            </div>
            <div   className='col-md-6 d-flex justify-content-end'>
                <img style={{width:'450px',height:'320px',marginRight:'40px' }} src={require('../../../assets/NGLV_images/Kenya School Children.jpg')} />
            </div>
        </div>
            <div style={{marginTop:'20px'}}>
<p style={{textAlign:'center',fontSize:'12px'}}>Being part of the family of Jesus Christ means you are now part of something meaningful and beautiful and bigger than yourself. You are part of a journey WITH God!
</p>
<p style={{textAlign:'center',fontSize:'12px'}}>This journey will take the rest of your life. It never stops. And God will never stop loving you and helping you.</p>
<p style={{textAlign:'left',fontSize:'12px'}}>


</p>
<div className='row'>
        <div className='col-md-6'>
        <p className='fsize' style={{textAlign:'left',lineHeight:2}}>
    <p className='fsize' style={{fontWeight:600}}>The journey of a Christian has many steps:</p>
    <li style={{lineHeight:2,marginLeft:'20px'}}>Hearing God’s Word</li>
    <li style={{lineHeight:2,marginLeft:'20px'}}>Believing God</li>
    <li style={{lineHeight:2,marginLeft:'20px'}}>Connecting with God</li>
    <li style={{lineHeight:2,marginLeft:'20px'}}>Living with God</li>
    <li style={{lineHeight:2,marginLeft:'20px'}}>Serving God’s People </li>
    <li className='fsize' style={{fontWeight:600,listStyleType:'none'}}>So Keep Going</li>
    <li style={{marginLeft:'20px'}}>Keep reading God’s Word, the Bible, to learn about Jesus and how to live as a Christian.</li>
    <li style={{marginLeft:'20px'}}>Pray to God telling Him why you love Him and asking Him for help.</li>
    <li style={{marginLeft:'20px'}}>Be baptized.</li>
    <li style={{marginLeft:'20px'}}>Gather with other Christians to pray and read the Bible.</li>
    <li style={{marginLeft:'20px'}}>Love God, and Love people!</li>
</p>
        </div>
        <div   className='col-md-6 d-flex justify-content-end'>
                <img style={{width:'450px',height:'320px',marginRight:'40px' }} src={require('../../../assets/NGLV_images/Kenya School Children 2.jpg')} />
            </div>
</div>

</div>

       </div>
                </div>
                </section>
                </div>
                <Footer />
        </>
     );
}
 
export default IWanttoAcceptJesus;